<template>
  <div v-if="printer">
    <h1>Printer</h1>
    <v-btn :to="{name:'printers'}">
      <v-icon>chevron_left</v-icon>Printers
    </v-btn>
    <v-btn @click="deletePrinter" color="error">
      <v-icon>delete</v-icon>
    </v-btn>
    <v-text-field label="Id" v-model="printer.id" :readonly="true" outline />
    <v-select
      label="Server"
      v-model="printer.serverid"
      :items="servers"
      item-value="id"
      item-text="name"
      outline
    />
    <v-text-field label="Code" v-model="printer.code" outline />
    <v-text-field label="Name" v-model="printer.name" outline />
    <v-text-field label="Local path" v-model="printer.localpath" outline />
    <v-text-field label="Remote path" v-model="printer.remotepath" outline />
    <v-btn @click="savePrinter">
      <v-icon>save</v-icon>Save
    </v-btn>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Printer",
  metaInfo() {
    return {
      title: "Printer",
      titleTemplate: "%s - Rest - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      printer: null,
      servers: null
    };
  },
  methods: {
    fetchPrinter() {
      nbmlaw
        .get(`/cors/admin/extras/printers/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.printer = response.data;
        });
    },
    fetchServers() {
      nbmlaw.get(`/cors/admin/extras/servers`).then(response => {
        // console.log(response.data);
        this.servers = response.data;
      });
    },
    savePrinter() {
      if (this.$route.params.id) {
        this.updatePrinter();
      } else {
        this.createPrinter();
      }
    },
    updatePrinter() {
      nbmlaw
        .put(
          `/cors/admin/extras/printers/${this.$route.params.id}`,
          this.printer
        )
        .then(() => {
          // console.log(response.data);
          this.$router.push({ name: "printers" });
        });
    },
    createPrinter() {
      nbmlaw.post(`/cors/admin/extras/printers`, this.printer).then(() => {
        // console.log(response.data);
        this.$router.push({ name: "printers" });
      });
    },
    deletePrinter() {
      if (confirm("Are you sure?")) {
        nbmlaw
          .delete(`/cors/admin/extras/printers/${this.$route.params.id}`)
          .then(() => {
            // console.log(response.data);
            this.$router.push({ name: "printers" });
          });
      }
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchPrinter();
        } else {
          this.printer = {};
        }
      }
    }
  },
  created() {
    this.fetchServers();
  }
};
</script>
